<template>
    <div class="content">
        <div class="header">
            <img src="../assets/logo.png">
            <span class="title">国家信息化计算机教育认证证书查询系统</span>
        </div>
        <div class="main">
            <div v-if="!InitFlagLoading" class="demo-spin-col">
                <Spin fix>
                    <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                    <div>加载中...</div>
                </Spin>
            </div>
            <div v-else>
                <span style="font-weight: bold;color: rgb(15, 65, 117);height: 20px;float: right;">结果显示</span>
                <div v-if="!isHasData" style="line-height: 400px;">查询无结果</div>
                <div v-else>
                    <table border="2" width="800" cellpadding="0" cellspacing="0" style="margin: auto">
                        <tbody>
                        <tr>
                            <td colspan="4" align="left" style="height: 55px;" width="85%">
                                <img src="../assets/icon_01.gif" width="20" height="22" style="border-width: 0">
                                <span style="font-size: 18px; font-weight: bold">基本信息</span>
                                <span style="font-weight: bold">Basic Information</span>
                            </td>
                            <td rowspan="3">
                                <img v-if="data.ImgPath !== null" :src="data.ImgPath" width="100" height="122" style="border-width: 0;margin:0;padding:0;">
                                <img v-else src="../../static/images/user_photo.jpg">
                            </td>
                        </tr>
                        <tr>
                            <td align="right" style="font-weight: bold; height: 35px; color: rgb(15,65,117);">姓名：</td>
                            <td align="left" colspan="3">&nbsp;{{data.Name}}</td>
                        </tr>
                        <tr>
                            <td width="170" align="right" style="font-weight: bold; height: 35px; color: rgb(15,65,117);">证件类型：</td>
                            <td width="185" align="left">&nbsp;{{data.IdCardType}}</td>
                            <td width="170" align="right" style="font-weight: bold; height: 35px; color: rgb(15,65,117);">证件号码：</td>
                            <td width="185" align="left">&nbsp;{{data.IdCard}}</td>
                        </tr>
                        </tbody>
                        <tbody v-for="(certItem,index) in data.CertDetails" :key="index">
                        <tr>
                            <td colspan="5" align="left" height="50">
                                <img src="../assets/icon_02.gif" width="20" height="22" style="border-width: 0">
                                <span style="font-size: 18px; font-weight: bold">证书信息</span>
                                <span style="font-weight: bold">Certificate Information</span>
                            </td>
                        </tr>
                        <tr>
                            <td align="right" height="35" style="font-weight: bold; color: rgb(15,65,117);">认证名称：</td>
                            <td align="left">&nbsp;{{certItem.CertName}}</td>
                            <td align="right" style="font-weight: bold; color: rgb(15,65,117);">证书编号：</td>
                            <td colspan="2" align="left">&nbsp;{{certItem.CertNum}}</td>
                        </tr>
                        <tr>
                            <td align="right" height="35" style="font-weight: bold; color: rgb(15,65,117);">准考证号：</td>
                            <td align="left">&nbsp;{{certItem.UniqueId}}</td>
                            <td align="right" style="font-weight: bold; color: rgb(15,65,117);">评定结果：</td>
                            <td colspan="2" align="left">&nbsp;合格</td>
                        </tr>
                        <tr>
                            <td align="right" height="35" style="font-weight: bold; color: rgb(15,65,117);">通过考核日期：</td>
                            <td colspan="4" align="left">&nbsp;{{certItem.PassTime.substring(0,10)}}</td>
                        </tr>
                        <tr>
                            <td align="right" style="font-weight: bold; color: rgb(15,65,117);">认证考试科目：</td>
                            <td colspan="4" align="left">
                                <p style="margin-top: 8px;"></p>
                                <ol style="list-style-position:inside;margin-left:10px;">
                                    <li v-for="(item,index) in certItem.SubjectNames" :key="index">{{index+1}}. {{item}}</li>
                                </ol>
                                <p style="margin-top: 8px;"></p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="footer">
            <span class="dhr"></span>
            Copyright© 2002-2019 www.exam.org.cn All Rights Reserved. Powered by Co-Education
        </div>
    </div>
</template>

<script>
    import {postCertQuery} from '../api/index'

    export default {
        name: 'ResultPage',
        data () {
            return {
                data: {},
                queryView:{
                    Name:"",
                    IdNum:""
                },
                isHasData: false,
                InitFlagLoading: false
            }
        },
        created() {
            this.postCertQuery();
        },
        methods: {
            postCertQuery(){
                this.queryView.Name = this.$route.query.Name? this.$route.query.Name: "";
                this.queryView.IdNum = this.$route.query.IdNum? this.$route.query.IdNum: "";
                postCertQuery(this.queryView).then(res=> {
                    if (res.StatusCode === 200) {
                        this.InitFlagLoading = true;
                        this.data = res.Data;
                        if(this.data !== null) {
                            let tempArr = Object.keys(this.data);
                            if(tempArr.length !== 0) {
                                this.isHasData = true;
                            }else {
                                this.isHasData = false;
                            }
                        }else {
                            this.$router.push({
                                name: 'Main'
                            })
                        }
                    } else {
                        this.$Message.error(res.Data);
                        this.$router.push({
                            name: 'Main'
                        })
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {
        width: 778px;
        margin: 0 auto;
    }

    .header {
        text-align: left;
        padding-top: 20px;
    }

    .header img {
        border-width: 0;
    }

    .title {
        font-size: 30px;
        font-weight: bold;
        color: rgb(15,65,117);
    }

    table {
        width: 798px;
    }

    table, tr, td {
        border: 2px solid #2498C6;
    }

    .certs-table tr:nth-child(1) {
        border-width: 0;
    }

    .dhr {
        display: inline-block;
        height: 1px;
        background-color: #999999;
        overflow: hidden;
        width: 99%;
        margin: 9px auto;
    }

    .demo-spin-col {
        position: relative;
        height: 400px;
        font-size: 15px;
    }

    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }

    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
</style>




// WEBPACK FOOTER //
// src/components/ResultPage.vue